module.exports = __webpack_public_path__ + "static/media/checkScope_2.3a472435.png";